import { AuthCompleteEmailVerificationAction, completeEmailVerification } from "auth/modules/actions";
import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";

import { State } from "redux/state";
import { Omit } from "utils/Types";
import { VerificationConfirmationPage, VerificationPageProps } from "../components/VerificationConfirmationPage";

type DispatchProps = Pick<VerificationPageProps, "confirmVerification">;
type StateProps = Pick<VerificationPageProps, "profile">;
type OwnProps = Omit<VerificationPageProps, keyof (DispatchProps & StateProps)>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (dispatch: ThunkDispatch<State, undefined, Action | AuthCompleteEmailVerificationAction>) => {
    return {
        confirmVerification() {
            dispatch(completeEmailVerification());
        }
    };
};

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (state: State) => ({
    profile: state.auth.profile
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VerificationConfirmationPage);
